export const txhhschip = {
  agencySlug: 'txhhs',
  appCode: 'TXHHS_CHIP',
  slug: 'txhhs',
  linkService: {
    form: {
      labels: {
        caseNumber: { id: 'txhhs_caseNumber' },
        zipCode: { id: 'txhhs_zipCode' },
      },
    },
  },
};
